import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Admin.css";

function Admin() {
  const [messages, setMessages] = useState([]);

  // Charger les messages depuis la base de données
  const fetchMessages = () => {
    axios
      .get("http://localhost:5000/api/messages")
      .then((response) => {
        setMessages(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des messages :", error);
      });
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  // Supprimer un message
  const handleDelete = (id) => {
    axios
      .delete(`http://localhost:5000/api/messages/${id}`)
      .then(() => {
        setMessages((prevMessages) =>
          prevMessages.filter((msg) => msg.id !== id)
        );
      })
      .catch((error) => {
        console.error("Erreur lors de la suppression du message :", error);
      });
  };

  return (
    <div className="admin-container">
      <h1>Gestion des Messages</h1>
      <table className="messages-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Email</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((msg) => (
            <tr key={msg.id}>
              <td>{msg.name}</td>
              <td>{msg.email}</td>
              <td>{msg.message}</td>
              <td>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(msg.id)}
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Admin;
